import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import MuiLink from '@mui/material/Link';
import { ConditionalWrapper } from '@qpr/components';
import { LandingCardProps } from '@qpr/landing-page/components/LandingPageCard';
import React from 'react';
import { Link } from 'react-router-dom';
import { isDataImage } from '../../../utils/gui-utils';
import { checkIfExternal, isValidUrl } from '../../../utils/url-utils';

const LandingPageCard = ({ name, link, image, enabled, tenant = '' }: LandingCardProps) => {
  const isActive = link && enabled;
  return (
    <ConditionalWrapper
      condition={checkIfExternal(link)}
      wrapper={(children: React.ReactNode) =>
        isActive ? (
          <MuiLink
            sx={{ textDecoration: 'none', color: 'text.primary' }}
            target="_blank"
            rel="noopener noreferrer"
            href={link}
            data-testid="card-link-external"
          >
            {children}
          </MuiLink>
        ) : (
          <>{children}</>
        )
      }
      wrapperFalse={(children: React.ReactNode) =>
        isActive ? (
          <MuiLink
            sx={{ textDecoration: 'none', color: 'text.primary' }}
            component={Link}
            to={`/${tenant}${link}`}
            data-testid="card-link-internal"
          >
            {children}
          </MuiLink>
        ) : (
          <>{children}</>
        )
      }
    >
      <Card
        sx={{
          width: '210px',
          height: '233px',
          display: 'block',
          backgroundColor: 'action.disabled',
          color: 'common.white',
          overflowY: name && name.length > 20 ? 'auto' : 'hidden',
          '&:hover': isActive
            ? {
                backgroundColor: 'action.active',
                cursor: 'pointer'
              }
            : {}
        }}
        data-testid="card-root"
      >
        <Box
          component="div"
          sx={{
            height: '55px',
            marginTop: '30px',
            marginBottom: '30px',
            right: '200px',
            display: 'block',
            marginLeft: 'auto',
            marginRight: 'auto',
            width: '50%'
          }}
          data-testid="avatar-div"
        >
          {image && (isValidUrl(image) || isDataImage(image)) && (
            <img alt="" src={image} data-testid="avatar-image" />
          )}
        </Box>
        <CardContent
          sx={{
            textAlign: 'center',
            fontSize: '24px',
            fontWeight: 'bold',
            paddingLeft: '15px',
            paddingTop: '40px'
          }}
          data-testid="card-title"
        >
          {name}
        </CardContent>
      </Card>
    </ConditionalWrapper>
  );
};

export default LandingPageCard;
